import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { BBSFUtilitiesModule, UtilityService, BBSFTranslateService } from 'bbsf-utilities';
import { TranslateService } from '@ngx-translate/core';
import{ToolbarModule} from '../_layout/components/toolbar/toolbar.module'
import { FilterPipe } from './filter-pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BBSFControlsModule } from 'bbsf-controls';

const routes: Routes = [
  {
    path: '', component: HomeComponent
  }
]

@NgModule({
  declarations: [HomeComponent,FilterPipe],
  imports: [
    CommonModule,
    InlineSVGModule,
    RouterModule.forChild(routes),
    ToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    BBSFControlsModule

  ],
  providers:[
     UtilityService,
  ]
})
export class HomeModule { }
